import { render, staticRenderFns } from "./DroppedOnRequest.vue?vue&type=template&id=87fe4edc&"
import script from "./DroppedOnRequest.vue?vue&type=script&lang=ts&"
export * from "./DroppedOnRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87fe4edc')) {
      api.createRecord('87fe4edc', component.options)
    } else {
      api.reload('87fe4edc', component.options)
    }
    module.hot.accept("./DroppedOnRequest.vue?vue&type=template&id=87fe4edc&", function () {
      api.rerender('87fe4edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Application/Sections/DroppedOnRequest.vue"
export default component.exports